
import {
  entitySlugForLocale,
  buildHreflangLinks,
  computeAlternateUrls,
} from '@/utils/hreflang'
import { buildOgLocaleMeta, buildOgImageMeta } from '@/utils/seo'
import ArticleStructuredData from '@/components/ArticleStructuredData.vue'
import ArticleShow from '@/components/ArticleShow.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import realisationRedirect from '@/mixins/realisationRedirect'
export default {
  name: 'BlogShow',
  components: {
    Breadcrumb,
    ArticleShow,
    ArticleStructuredData,
  },
  mixins: [realisationRedirect],
  data() {
    return {
      article: null,
      breadcrumb_list: [],
      languageMap: {},
    }
  },
  computed: {
    ogImage() {
      const img = this.article?.images?.[0]
      if (!img?.url) {
        return {
          url: `${this.$config.url}/logo_og.png`,
          width: 512,
          height: 512,
        }
      }
      return {
        url: img.url.startsWith('http')
          ? img.url
          : `${this.$config.url}${img.url}`,
        width: img.width || null,
        height: img.height || null,
      }
    },
  },
  async fetch() {
    await Promise.all([
      this.$getLanguageMap().then(map => { this.languageMap = map }),
      this.$articleService
      .fetchBlogShow(this.$route.params.slug)
      .then(({ data }) => {
        this.article = data
        this.breadcrumb_list = [
          {
            text: this.$t(
              'pages.blogLedAccessoiresVehicules.slug.breadcrumbHome'
            ),
            to: { name: 'index' },
          },
          {
            text: this.$t(
              'pages.blogLedAccessoiresVehicules.slug.breadcrumbBlog'
            ),
            to: {
              name: 'blog-led-accessoires-vehicules',
            },
          },

          {
            text: this.article.title,
            to: {
              name: 'blog-led-accessoires-vehicules-slug',
              params: {
                slug: this.article.slug,
              },
            },
          },
        ]
      })
      .catch(async error => {
        const redirected =
          error?.response?.status === 404 &&
          (await this.redirectToRealisation(this.$route.params.slug).catch(
            () => false
          ))
        if (!redirected) {
          this.$404Error()
        }
      }),
    ])

    if (this.article) {
      computeAlternateUrls({
        locales: this.$i18n.locales,
        localePath: this.localePath,
        routeName: 'blog-led-accessoires-vehicules-slug',
        buildParams: code => {
          const slug = entitySlugForLocale(this, this.article, code)
          return slug ? { slug } : null
        },
        store: this.$store,
      })
    }
  },
  head() {
    if (this.article) {
      return {
        title: this.article.meta_title
          ? this.article.meta_title
          : this.article.title,
        link: [
          ...(this.article.images && this.article.images[0]
            ? [
                {
                  rel: 'preload',
                  as: 'image',
                  fetchpriority: 'high',
                  href: this.$device.isMobile
                    ? this.$cropUrl(
                        this.article.images[0],
                        '_',
                        '_',
                        this.article.images[0].extension,
                        100
                      )
                    : this.$cropUrl(
                        this.article.images[0],
                        1000,
                        700,
                        this.article.images[0].extension,
                        100
                      ),
                },
              ]
            : []),
          {
            rel: 'canonical',
            hid: 'i18n-can',
            href:
              this.$config.url +
              this.localePath({
                name: 'blog-led-accessoires-vehicules-slug',
                params: { slug: this.article.slug },
              }),
          },
          ...buildHreflangLinks({
            locales: this.$i18n.locales,
            configUrl: this.$config.url,
            localePath: this.localePath,
            routeName: 'blog-led-accessoires-vehicules-slug',
            buildParams: code => {
              const slug = entitySlugForLocale(this, this.article, code)
              return slug ? { slug } : null
            },
            store: this.$store,
          }),
        ],
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.article.meta_description,
          },
          { hid: 'og:type', property: 'og:type', content: 'article' },
          {
            hid: 'og:url',
            property: 'og:url',
            content:
              this.$config.url +
              this.localePath({
                name: 'blog-led-accessoires-vehicules-slug',
                params: { slug: this.article.slug },
              }),
          },
          {
            hid: 'og:title',
            property: 'og:title',
            content: this.article.meta_title
              ? this.article.meta_title
              : this.article.title,
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: this.article.meta_description,
          },
          {
            hid: 'og:site_name',
            property: 'og:site_name',
            content: 'AGM Vision',
          },
          ...buildOgLocaleMeta(this.$i18n.locale),
          ...buildOgImageMeta({
            url: this.ogImage.url,
            width: this.ogImage.width,
            height: this.ogImage.height,
            alt: this.article.meta_title || this.article.title,
          }),
          {
            hid: 'twitter:title',
            name: 'twitter:title',
            content: this.article.meta_title || this.article.title,
          },
          {
            hid: 'twitter:description',
            name: 'twitter:description',
            content: this.article.meta_description,
          },
        ],
      }
    }
  },
}
